import {
  Anchor,
  Autocomplete,
  Box,
  Button,
  Input,
  Select,
} from "@mantine/core";
import {
  Input as AntdInput,
  Badge,
  DatePicker,
  Upload,
  notification,
} from "antd";
import {
  IconArrowRight,
  IconBuilding,
  IconCalendar,
  IconFileDescription,
  IconFileText,
  IconId,
  IconUser,
} from "@tabler/icons-react";
import { useCallback, useEffect, useRef, useState } from "react";

import Papa from "papaparse";
import ProductionPlan from "./ProductionPlan";
import { orpcClient } from "@/lib/orpc-client";
import { single } from "@/lib/orpc-batch";
import { useData } from "@/utility/state/contextAPI";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

function AddQuotationListPage() {
  const { t } = useTranslation();
  const [currentStage, setCurrentStage] = useState(0);

  const [quotationData, setQuotationData] = useState({
    date: "",
    remarks: "",
    partner: "",
    partnerAddress: {
      city: null,
      district: null,
      postalCode: null,
      address: null,
    },
    projectStatus: "quotation",
    name: "",
    company: localStorage.getItem("companyId"),
  });
  const [uploadState, setUploadState] = useState(false);
  const [fileUpload, setFileUpload] = useState([]);
  const [meetingRecordUpload, setMeetingRecordUpload] = useState([]);
  const [notesUpload, setNotesUpload] = useState([]);
  const [contractFileUpload, setContractFileUpload] = useState([]);

  const [partnerData, setPartnerData] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const searchTimeoutRef = useRef(null);
  const [api, contextHolder] = notification.useNotification();

  const {
    modal: { contextOpenModal, contextCloseModal, contextSetModalContent },
  } = useData();
  const navigate = useNavigate();
  const { date, projectStatus, remarks, partner, partnerAddress, name } =
    quotationData || {};

  const { city, district, postalCode, address } = partnerAddress || {};

  const handleDataChange = (name, value) => {
    setQuotationData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleChangePartnerData = (value, partnerData) => {
    //let match = value.match(/ID:\s*(\d+)/);
    let match = value.match(/ID:\s*([a-zA-Z0-9-]+)/);
    let idNumber = match ? match[1] : null;
    let selectedData = partnerData.filter((e) => e?.id == idNumber)[0];

    handleDataChange("partner", selectedData?.id);
  };

  const fetchPartnerData = useCallback(async (searchName = "") => {
    try {
      const result = await orpcClient.partner.list({});

      let filteredData = result;
      if (searchName) {
        filteredData = result.filter((partner: any) =>
          partner.name?.toLowerCase().includes(searchName.toLowerCase())
        );
      }

      setPartnerData(filteredData as any);
    } catch (error) {
      console.error("Error fetching partner data:", error);
    }
  }, []);

  const handleSearchChange = (value) => {
    setSearchValue(value);

    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    searchTimeoutRef.current = setTimeout(() => {
      fetchPartnerData(value);
    }, 300);
  };

  const handleSubmit = async ({ data }) => {
    console.log("data", data);
    try {
      const { company, projectStatus, partner, date, partnerAddress, ...rest } =
        data;

      if (!partner) {
        return api.error({
          message: t("quotation.validationError"),
          description: <div>{t("quotation.pleaseSelectPartner")}</div>,
          placement: "topLeft",
          duration: 3000,
        });
      }

      const createData = {
        ...rest,
        partnerId: partner,
        date: new Date(date),
        partnerAddress: partnerAddress
          ? {
              ...partnerAddress,
              postalCode: partnerAddress.postalCode
                ? Number(partnerAddress.postalCode)
                : null,
            }
          : undefined,
        status: "normal",
      };
      const result = await single(orpcClient.project.create([createData]));
      setCurrentStage(1);
      console.log("result", result);
      // if (result) {
      //   const projectNodeResult = await orpcClient.projectNode.create({
      //     projectId: result.id,
      //     nodeType: "building",
      //   });

      //   if (projectNodeResult) {
      //     const updateAccountsProject = await orpcClient.project.update({
      //       id: result.id,
      //       productionPlan: {
      //         nodes: [
      //           {
      //             id: "0",
      //             documentId: projectNodeResult.id,
      //             type: "building",
      //             data: { label: "Node A", name: "Alpha", type: "building" },
      //             position: { x: 0, y: 50 },
      //           },
      //         ],
      //         edges: [],
      //       },
      //     });
      //     console.log("updateAccountsProject", updateAccountsProject);
      //     if (updateAccountsProject) {
      //       setCurrentStage(1);
      //     }
      //   }
      // }
    } catch (error) {
      console.error("Error post department data:", error);
      return api.error({
        message: `Notification`,
        description: <div>{error?.message}</div>,
        placement: "topLeft",
        duration: 0,
      });
    }
  };
  const handleChangeImg = async (info, setState) => {
    setUploadState(true);
    if (!uploadState) {
      const file = info.file.originFileObj;

      try {
        const sasUrlData = await orpcClient.storage.createBlobSasUrl({
          fileName: file.name,
          contentType: file.type,
        });

        console.log("sasUrlData", sasUrlData);

        const uploadResponse = await fetch(sasUrlData.blobSasUrl, {
          method: "PUT",
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": file.type,
          },
          body: file,
        });

        console.log("uploadResponse", uploadResponse);

        if (uploadResponse.ok) {
          setState((prev) => [
            ...prev,
            {
              id: Date.now(),
              name: file.name,
              url: sasUrlData.blobUrl,
            },
          ]);
        } else {
          console.error("File upload failed:", uploadResponse.statusText);
          api.error({
            message: t("quotation.uploadErrorTitle"),
            description: <div>{t("quotation.fileUploadFailed")}</div>,
            placement: "topLeft",
            duration: 3000,
          });
        }
      } catch (error) {
        console.error("Error uploading file:", error);
        api.error({
          message: t("quotation.uploadErrorTitle"),
          description: <div>{error?.message || t("quotation.fileUploadFailed")}</div>,
          placement: "topLeft",
          duration: 3000,
        });
      }
      setUploadState(false);
    }
  };

  const handleChangeContractImg = async (info) => {
    setUploadState(true);
    if (!uploadState) {
      const file = info.file.originFileObj;

      try {
        const sasUrlData = await orpcClient.storage.createBlobSasUrl({
          fileName: file.name,
          contentType: file.type,
        });

        const uploadResponse = await fetch(sasUrlData.blobSasUrl, {
          method: "PUT",
          headers: {
            "x-ms-blob-type": "BlockBlob",
            "Content-Type": file.type,
          },
          body: file,
        });

        if (uploadResponse.ok) {
          setContractFileUpload([
            {
              id: Date.now(),
              name: file.name,
              url: sasUrlData.blobUrl,
            },
          ]);
        } else {
          console.error("File upload failed:", uploadResponse.statusText);
          api.error({
            message: t("quotation.uploadErrorTitle"),
            description: <div>{t("quotation.contractUploadFailed")}</div>,
            placement: "topLeft",
            duration: 3000,
          });
        }
      } catch (error) {
        console.error("Error uploading contract file:", error);
        api.error({
          message: t("quotation.uploadErrorTitle"),
          description: (
            <div>{error?.message || t("quotation.contractUploadFailed")}</div>
          ),
          placement: "topLeft",
          duration: 3000,
        });
      }
      setUploadState(false);
    }
  };
  console.log("fileUpload", fileUpload);

  const handleChangeAddressData = (value, type) => {
    setQuotationData((prevData) => ({
      ...prevData,
      partnerAddress: {
        ...prevData?.partnerAddress,
        [type]: value,
      },
    }));
  };

  const handleChangeCSV = (info, setFileUpload) => {
    const file = info.file.originFileObj;
    if (file && file.type === "text/csv") {
      const reader = new FileReader();
      reader.onload = (e) => {
        const text = e.target.result;
        Papa.parse(text, {
          header: true,
          encoding: "UTF-8", // Ensure UTF-8 encoding
          complete: (result) => {
            console.log("Parsed CSV:", result.data);
            setFileUpload((prev) => [
              ...prev,
              { id: Date.now(), name: file.name, data: result.data },
            ]);
          },
          error: (error) => console.error("CSV Parsing Error:", error),
        });
      };

      reader.readAsText(file, "utf-8"); // Specify UTF-8 encoding
    } else {
      setFileUpload((prev) => [...prev, { id: Date.now(), name: file.name }]);
    }
  };

  useEffect(() => {
    fetchPartnerData();
  }, [fetchPartnerData]);

  return currentStage === 0 ? (
    <div className="flex min-h-full items-start justify-center p-8">
      {contextHolder}
      <div className="w-[765px] rounded-xl bg-white p-14">
        <>
          <div className="py-3 text-6xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("quotation.createProjectList") || "建立專案列表"}
          </div>
          <div className="py-3 text-2xl font-bold" style={{ color: "#6F6F6F" }}>
            {t("quotation.basicInfo") || "基本資訊"}
          </div>
          <div className="flex py-4">
            <div>
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.name") || "名稱"}
              </div>
              <Input
                placeholder={t("quotation.namePlaceholder")}
                value={name}
                leftSection={<IconFileText size={16} />}
                onChange={({ target: { value } }) =>
                  handleDataChange("name", value)
                }
              />
            </div>
            <div className="pl-3">
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.date") || "日期"}*
              </div>
              <DatePicker
                placeholder={t("quotation.datePlaceholder")}
                style={{ maxWidth: "200px" }}
                onChange={(e) =>
                  handleDataChange("date", e.format("YYYY-MM-DD"))
                }
              />
            </div>
          </div>

          <div className="flex py-4">
            <div>
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.customer") || "合作方（客戶）"}*
              </div>
              <Autocomplete
                placeholder={t("quotation.partnerPlaceholder")}
                leftSection={<IconUser size={16} />}
                data={partnerData?.map((t) => t?.name + ` (ID: ${t?.id})`)}
                value={searchValue}
                onChange={(e) => {
                  handleSearchChange(e);
                  handleChangePartnerData(e, partnerData);
                }}
                onOptionSubmit={(e) => {
                  handleSearchChange(e);
                  handleChangePartnerData(e, partnerData);
                }}
              />
            </div>
            {/* <div className="pl-3">
              <div style={{ color: "#6F6F6F" }}>{t("quotation.remarks") || "備註"}</div>
              <AntdInput.TextArea
                placeholder="Input component"
                leftSection={<IconFileDescription size={16} />}
                value={remarks}
                onChange={(e) => handleDataChange("remarks", e.target.value)}
              />
            </div> */}
          </div>
          <div style={{ color: "#6F6F6F" }}>
            {t("quotation.customer") || "合作方（客戶）"}{" "}
            {t("quotation.address") || "地址"}
          </div>
          <div className="flex tems-center justify-center">
            <div className="">
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.city") || "縣市"}*
              </div>
              <Input
                placeholder={t("quotation.cityPlaceholder")}
                leftSection={<IconBuilding size={16} />}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "city")
                }
              />
            </div>

            <div className=" pl-2">
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.district") || "行政區"}*
              </div>
              <Input
                placeholder={t("quotation.districtPlaceholder")}
                leftSection={<IconBuilding size={16} />}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "district")
                }
              />
            </div>
            <div className=" pl-2">
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.postalCode") || "郵遞區號"}*
              </div>
              <Input
                placeholder={t("quotation.postalCodePlaceholder")}
                leftSection={<IconId size={16} />}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "postalCode")
                }
              />
            </div>
            <div className="pl-2">
              <div style={{ color: "#6F6F6F" }}>
                {t("quotation.address") || "地址"}*
              </div>
              <Input
                placeholder={t("quotation.fullAddressPlaceholder")}
                leftSection={<IconBuilding size={16} />}
                onChange={(e) =>
                  handleChangeAddressData(e.target.value, "address")
                }
              />
            </div>
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>
              {t("quotation.remarks") || "備註"}
            </div>
            <AntdInput.TextArea
              placeholder={t("quotation.remarksPlaceholder")}
              leftSection={<IconFileDescription size={16} />}
              value={remarks}
              onChange={(e) => handleDataChange("remarks", e.target.value)}
            />
          </div>
          {/* <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>建立報價分析表（綁定報價單）</div>
            <Input
              placeholder="Input component"
              leftSection={<IconFileText size={16} />}
            />
          </div> */}
          {/* <div className="py-4">
            <div style={{ color: '#6F6F6F' }}>BOM表</div>
            <Button
              variant="default"
              color="gray"
              disabled={true}
              onClick={() => navigate('/hrMainPage/steelAssemblyBOM')}
            >
              <IconArrowRight size={16} />
              材料BOM
            </Button>
            <Button
              variant="default"
              color="gray"
              disabled={true}
              style={{ marginLeft: '1.5rem' }}
              onClick={() => navigate('/hrMainPage/steelAssemblyBOM')}
            >
              <IconArrowRight size={16} />
              螺絲BOM
            </Button>
          </div> */}
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>
              {t("quotation.fileUpload") || "公務檔案"}
            </div>
            <Upload
              name="avatar"
              showUploadList={false}
              onChange={(info) => handleChangeImg(info, setFileUpload)}
            >
              <Button variant="default">
                {t("quotation.addFile") || "新增檔案"}
              </Button>
            </Upload>
            <div>
              {fileUpload?.map((t) => (
                <div
                  key={t?.id}
                  className="flex justify-between items-center p-2 border-b"
                >
                  <span>{t?.name}</span>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() =>
                      setFileUpload((prev) =>
                        prev.filter((file) => file.id !== t?.id)
                      )
                    }
                  >
                    ❌
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>{t("quotation.meetingRecords")}</div>
            <Upload
              name="avatar"
              showUploadList={false}
              onChange={(info) => handleChangeImg(info, setMeetingRecordUpload)}
            >
              <Button variant="default">
                {t("quotation.addFile") || "新增檔案"}
              </Button>
            </Upload>
            <div>
              {meetingRecordUpload?.map((t) => (
                <div
                  key={t?.id}
                  className="flex justify-between items-center p-2 border-b"
                >
                  <span>{t?.name}</span>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() =>
                      setMeetingRecordUpload((prev) =>
                        prev.filter((file) => file.id !== t?.id)
                      )
                    }
                  >
                    ❌
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>{t("quotation.importantNotes")}</div>
            <Upload
              name="avatar"
              showUploadList={false}
              onChange={(info) => handleChangeImg(info, setNotesUpload)}
            >
              <Button variant="default">
                {t("quotation.addFile") || "新增檔案"}
              </Button>
            </Upload>
            <div>
              {notesUpload?.map((t) => (
                <div
                  key={t?.id}
                  className="flex justify-between items-center p-2 border-b"
                >
                  <span>{t?.name}</span>
                  <button
                    className="text-red-500 hover:text-red-700"
                    onClick={() =>
                      setNotesUpload((prev) =>
                        prev.filter((file) => file.id !== t?.id)
                      )
                    }
                  >
                    ❌
                  </button>
                </div>
              ))}
            </div>
          </div>
          <div className="py-4">
            <div style={{ color: "#6F6F6F" }}>
              {t("quotation.contractUpload") || "財務檔案"}
            </div>
            <Upload
              name="avatar"
              showUploadList={false}
              onChange={(info) => handleChangeContractImg(info)}
            >
              <Button variant="default">
                {t("quotation.addFile") || "新增檔案"}
              </Button>
            </Upload>
            <div>
              {Array.isArray(contractFileUpload) &&
                contractFileUpload?.map((t) => (
                  <div
                    key={t?.id}
                    className="flex justify-between items-center p-2 border-b"
                  >
                    <span>{t?.name}</span>
                    <button
                      className="text-red-500 hover:text-red-700"
                      onClick={() =>
                        setContractFileUpload((prev) =>
                          prev.filter((file) => file.id !== t?.id)
                        )
                      }
                    >
                      ❌
                    </button>
                  </div>
                ))}
            </div>
          </div>

          <div className="flex">
            <Button
              variant="default"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() => navigate("/hrMainPage/projectQuotation")}
            >
              {t("quotation.cancel") || "取消"}
            </Button>
            <Button
              variant="filled"
              color="gray"
              style={{ width: "100%", margin: "1rem" }}
              radius="md"
              onClick={() =>
                handleSubmit({
                  data: {
                    ...quotationData,
                    attachment: [
                      ...(Array.isArray(fileUpload) ? fileUpload.map((t) => t?.url) : []),
                      ...(Array.isArray(meetingRecordUpload) ? meetingRecordUpload.map((t) => t?.url) : []),
                      ...(Array.isArray(notesUpload) ? notesUpload.map((t) => t?.url) : []),
                    ],
                    contractFile:
                      Array.isArray(contractFileUpload) &&
                      contractFileUpload.length > 0
                        ? contractFileUpload[0]?.url
                        : null,
                  },
                })
              }
            >
              {t("quotation.create") || "建立"}
            </Button>
          </div>
        </>
      </div>
    </div>
  ) : (
    <div className="flex min-h-full items-start justify-center p-14 text-center">
      <div className="w-[487px] rounded-xl bg-white p-8">
        <div style={{ color: "#6F6F6F" }}>
          {t("quotation.createProjectListSuccess") || "建立專案列表成功！"}
        </div>
        <Button
          variant="filled"
          color="gray"
          style={{ width: "100%", margin: "1rem 0" }}
          radius="md"
          onClick={() => navigate("/hrMainPage/projectQuotation")}
        >
          {t("quotation.confirm") || "確定"}
        </Button>
      </div>
    </div>
  );
}
export default AddQuotationListPage;
